<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>{{ rowId ? '编辑' : '创建' }}</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/ourteam')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="130px"
        ref="formData"
      >
        <el-form-item label="排序" prop="sort">
          <el-input
            clearable
            v-model="formData.sort"
            @input="formData.sort = formData.sort.replace(/^(0+)|[^\d]+/g, '')"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="图片" prop="logo">
          <imageUpload v-model="formData.logo" :isShowTip="false" :limit="1" />
        </el-form-item>
        <el-form-item label="是否推送公众号" prop="pushMp">
          <el-radio-group v-model="formData.pushMp" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否启用公众号" prop="pushMpFlag">
          <el-radio-group v-model="formData.pushMpFlag" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推官网" prop="pushOfficialWebsite">
          <el-radio-group v-model="formData.pushOfficialWebsite" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用官网" prop="pushOfficialWebsiteFlag">
          <el-radio-group
            v-model="formData.pushOfficialWebsiteFlag"
            size="small"
          >
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>保存</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="reset"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>
      <!-- <tz-form
        width="130px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
        @cleanFn="resultClean"
      ></tz-form> -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addOperaCompany, getId, updateOperaCompany } from '@/api/operacompany'
// import { uploadFile } from '@/api/advertising'

// import { scriptList } from '@/api/scriptis'
// import { queryEquipment } from '@/api/dictionary'

export default {
  data() {
    return {
      resultSelect: true,
      formData: {},
      itemList: [],
      photoList: [],
      rowId: null,
      rules: {
        // company: [{ required: true, message: '公司名称必填', trigger: 'blur' }]
        // itemType: [
        //   { required: true, message: '事项类型必填', trigger: 'blur' }
        // ],
        // itemName: [{ required: true, message: '事项名称必填', trigger: 'blur' }]
      }
    }
  },

  mounted() {
    let rowId = this.$route.query.id
    if (rowId && rowId != 'null') {
      this.rowId = rowId
      this.handleUpdate(this.rowId)
    } else {
      this.reset()
    }
  },
  methods: {
    /** 修改按钮操作 */
    handleUpdate(row) {
      // let deviceRow = []
      // let deviceIds = []
      this.reset()
      // const id = row.id || this.ids
      getId({ id: row }).then((response) => {
        let formData = response.data

        this.formData = formData
        console.log(this.photoList)
      })
    },
    // 监听radio框变化
    handleClick(val) {
      this.formData.resultValue = ''
      console.log(val)
      if (val === 1) {
        this.resultSelect = true
      } else if (val === 2) {
        this.resultSelect = false
      }
    },
    // 重置
    clearFn() {
      this.resultSelect = true
      this.$refs['formData'].resetFields()
    },
    // 表单重置
    reset() {
      this.formData = {
        id: null,
        company: null,
        logo: null,
        sort: null,
        type: 2, //团队
        pushMp: 2, //推送公众号
        pushMpFlag: 2, //公众号是否启用
        pushOfficialWebsite: 1, //是否推官网
        pushOfficialWebsiteFlag: 1 //官网是否启用
      }
      this.$refs['formData'].resetFields()
    },

    // 提交
    submitFn() {
      console.log(this.formData, '报告创建')
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          // this.$loading({
          //   text: '报告添加中'
          // })

          // let addparams = {
          //   itemName: this.formData.itemName,
          //   itemType: this.formData.itemType,
          //   sort: this.formData.sort,
          //   shows: this.formData.shows,
          //   status: this.formData.status,
          //   scriptId: this.formData.scriptId,
          //   resultType: this.formData.resultType,
          //   resultValue: this.formData.resultValue,
          //   qualifiedType: this.formData.qualifiedType
          // }
          // console.log(addparams)
          if (this.formData.id == null) {
            addOperaCompany(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          } else {
            updateOperaCompany(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
</style>
